
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/product/[id]/faq",
      function () {
        return require("private-next-pages/admin/product/[id]/faq/index.js");
      }
    ]);
  